import axiosInstance from "services/service-instance";

const fetchBankAccountsList = (params) =>
    axiosInstance.get("/company/bank-account/", {
        params
    });

const getPartnerBankAccountList = (partner_bank_id) =>
    axiosInstance.get("/company/partner-bank-account/", {
        params: {
            partner_bank_id
        }
    });

const createNewBankAccounts = (data) =>
    axiosInstance.post("/company/bank-account/", data);

const updateExistingBankAccounts = (data) =>
    axiosInstance.post("/company/bank-account/", data);
    
const getLendingPartners = () =>
    axiosInstance.get("/master/partner-bank/list/", {
        params: {
            paginate: false
        }
    });

const getLendingPartnerAccounts = (params) =>
    axiosInstance.get("/company/partner-bank-account/", {
        params
    });
const createNewLenderAccounts = (data) =>
    axiosInstance.post("/company/partner-bank-account/", data);

const updateExistingLenderAccounts = (data) =>
    axiosInstance.post("/company/partner-bank-account/", data);

export default {
    fetchBankAccountsList,
    getPartnerBankAccountList,
    createNewBankAccounts,
    updateExistingBankAccounts,
    getLendingPartners,
    getLendingPartnerAccounts,
    createNewLenderAccounts,
    updateExistingLenderAccounts
};